// src/hooks/useContextualData.js - FIXED TO USE EXISTING getSessionLearners
import { useState, useEffect } from 'react';
import { AssessmentService } from '../services/taskService';
import { SessionService } from '../services/sessionService';
import { AttendanceService } from '../services/attendanceService';
import { useAuth } from '../contexts/AuthContext';

export const useContextualData = () => {
  const { activeContext, userProfile } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [submissions, setSubmissions] = useState([]);
  const [marks, setMarks] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [sessionLearners, setSessionLearners] = useState([]);
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadData();
  }, [activeContext]);

  const loadData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Load core data
      const [tasksData, submissionsData, marksData, sessionsData, attendanceData] = await Promise.all([
        AssessmentService.getAssessmentTasks(),
        AssessmentService.getTaskSubmissions(),
        AssessmentService.getLearnerMarks(),
        SessionService.getUserSessions(),
        AttendanceService.getAttendanceRecords()
      ]);

      setTasks(tasksData);
      setSubmissions(submissionsData);
      setMarks(marksData);
      setSessions(sessionsData);
      setAttendanceRecords(attendanceData);

      // Load session learners if we have context and user profile
      if (activeContext?.id && userProfile?.grades?.length && userProfile?.subjects?.length) {
        const learnersData = await SessionService.getSessionLearners(
          activeContext.id,
          userProfile.grades,
          userProfile.subjects[0] // Use first subject as default
        );
        setSessionLearners(learnersData);
      }

    } catch (err) {
      console.error('Error loading contextual data:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const refreshData = () => {
    loadData();
  };

  return {
    tasks,
    submissions,
    marks,
    sessions,
    sessionLearners, // Now properly loaded
    attendanceRecords,
    loading,
    error,
    activeContext,
    refreshData
  };
};